import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { Button } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../../localization/labels";
import EntityRelationshipService from "../../../../../services/EntityRelationshipService";
import EntityRelationshipTypeService from "../../../../../services/EntityRelationshipTypeService";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import KnowledgeService from "../../../../../services/KnowledgeService";
import CommonUtil from "../../../../../utils/CommonUtil";
import { constants } from "../../../../../utils/Constants";
import PathUtil from "../../../../../utils/PathUtil";
import SecurityUtils from "../../../../../utils/SecurityUtils";
import {
  entityRelationshipValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import TableUtils from "../../../../core/Table/TableUtils";
import { paths } from "../../../../paths";
import KnowledgeItemsLookup from "../../../Lookups/KnowledgeItemsLookup";
import ControlledTableComponentWithDialog from "../../../page/ControlledTableComponentWithDialog";
import EntityRelationships from "./EntityRelationships";

class EntityRelationshipsContainer extends ControlledTableComponentWithDialog {
  constructor(props) {
    super(props);

    this.entityRelationshipService = new EntityRelationshipService(
      this.keycloak
    );
    this.entityRelationshipTypeService = new EntityRelationshipTypeService(
      this.keycloak
    );
    this.knowledgeService = new KnowledgeService(this.keycloak);

    this.state = {
      ...this.state,
      contextMenuItems: [
        {
          label: labels.open,
          callback: this.open,
          menuItemType: constants.MENU_ITEM_TYPE_OPEN,
          checkSecurity: true,
          entitySelector: this.getRowEntitySelector()
        },
        {
          label: labels.newTab,
          callback: this.openInNewTab,
          menuItemType: constants.MENU_ITEM_TYPE_NEW_TAB,
          checkSecurity: true,
          entitySelector: this.getRowEntitySelector()
        }
      ],
      disabled: true
    };

    this.allInheritedDataShouldBeDefined = true;
    this._isCompactViewEntities = true;
  }

  getInheritedDataService() {
    return new EntityRelationshipService(this.keycloak);
  }

  inheritedDataPropNames = ["entityRelationships", "entity"];

  resetEntity = () => {
    const entity = this.getInheritedObjectSafely(
      this.inheritedDataPropNames[1]
    );
    return {
      entity: {
        id: entity.id,
        name: entity.name,
        type: entity.type
      },
      relatedEntity: undefined,
      entityRelationshipType: undefined,
      noName: true,
      noDescription: true,
      noDateRange: true
    };
  };

  initialSortInfo() {
    return {
      orderBy: "relatedEntity.id",
      direction: "asc"
    };
  }

  onSelectedEntityLoad = data => {
    this.setState({
      newEntity: {
        ...data,
        noName: true,
        noDescription: true,
        noDateRange: true
      },
      oldEntity: {
        ...data,
        noName: true,
        noDescription: true,
        noDateRange: true
      },
      show: true,
      disabled: false,
      isNew: false
    });
    this.additionalDataLoad(data);
  };

  componentDidMount() {
    super.componentDidMount();
    this.loadEntityRelationshipTypes();
    this.props.setAddRelatedEntityRelationship &&
      this.props.setAddRelatedEntityRelationship(
        this.addRelatedEntityRelationship
      );
  }

  loadAfterReset() {
    const entity = this.getInheritedObject(this.inheritedDataPropNames[1]);
    const entityRelationships = this.getInheritedObject(
      this.inheritedDataPropNames[0]
    );

    const isReadyForReset = entity && !entityRelationships;

    if (isReadyForReset) {
      this.loadAllEntityRelationships();
    }

    return isReadyForReset;
  }

  resetData() {
    const entityRelationships = this.getInheritedObject(
      this.inheritedDataPropNames[0]
    );
    if (entityRelationships) {
      this.props.setInitial(undefined);
    }
  }

  loadAllEntityRelationships = () => {
    const entity = this.getInheritedObject(this.inheritedDataPropNames[1]);
    const entityRelationships = this.getInheritedObject(
      this.inheritedDataPropNames[0]
    );

    if (entity?._links && !entityRelationships) {
      this.prepareCall(
        this.getInheritedDataService().getEntitiesWithParams(
          entity._links.entityRelationshipsCompactView.href,
          undefined,
          { orderBy: "relatedEntity.id", direction: "asc" },
          this.onLoadAllEntityRelationships,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  onLoadAllEntityRelationships = data => {
    this.props.setInitial(CommonUtil.getDataContent(data) || []);
  };

  loadEntityRelationshipTypes = () => {
    this.prepareCall(
      this.entityRelationshipTypeService.getEntities(
        activeFilterPageInfo,
        undefined,
        this.onTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onTypesLoad = data => {
    this.setState({
      entityRelationshipTypes: data._embedded ? data._embedded.content : []
    });
  };

  getRowEntitySelector = () => {
    return "relatedEntity";
  };

  columns = [
    {
      dataField: "id",
      hidden: true
    },
    {
      dataField: "relatedEntity.id",
      text: labels.id,
      classes: "column-id",
      headerClasses: "column-header-id",
      formatter: (cell, row, index) =>
        TableUtils.textFormatter(cell, row, index, {
          entitySelector: this.getRowEntitySelector()
        })
    },
    {
      dataField: "relatedEntity.name",
      text: labels.name,
      headerClasses: "column-header",
      formatter: (cell, row, index) =>
        TableUtils.textFormatter(cell, row, index, {
          entitySelector: this.getRowEntitySelector()
        })
    },
    {
      dataField: "entityRelationshipType.name",
      text: labels.entityRelationshipType,
      headerClasses: "column-header",
      formatter: (cell, row, index) =>
        TableUtils.textFormatter(cell, row, index, {
          entitySelector: this.getRowEntitySelector()
        })
    },
    {
      dataField: "action",
      isDummyField: true,
      text: labels.actions,
      headerClasses: "column-header-id",
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) =>
          this.onEditClick(row)
      },
      formatter: (cellContent, row) => (
        <div className="column-id">
          <Button
            className="fa fa-edit fa-2x buttonStyle"
            title={labels.edit}
            size="sm"
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              this.onEditClick(row);
            }}
          />
        </div>
      )
    }
  ];

  open = row => {
    if (
      SecurityUtils.partyHasPermissionOnEntity(
        row.relatedEntity,
        constants.OPERATION_READ
      )
    ) {
      this.changePath(
        this.createEntityPath(row.relatedEntity),
        row.relatedEntity.name
      );
    }
  };

  openInNewTab = row => {
    window.open(this.createEntityPath(row.relatedEntity), "_blank", "noopener");
  };

  createEntityPath = entity => {
    return PathUtil.itemPath(paths.KNOWLEDGE_ITEM, entity.id);
  };

  possibleSizesPerPage() {
    return [3, 5, 10];
  }

  validator = entity => {
    return validateEntity(entity, validationRules.generalData);
  };

  addRelatedEntityRelationship = relatedEntity => {
    this.setState({
      show: true,
      disabled: true,
      isNew: true,
      newEntity: { ...this.resetEntity(), relatedEntity: relatedEntity }
    });
  };

  inputFields = () => [
    {
      label: labels.relatedEntity,
      controlId: "relatedEntity",
      content: (
        <KnowledgeItemsLookup
          omittedKnowledgeItem={this.state.newEntity?.entity}
          onChange={this.handleDialogChange}
          controlId="relatedEntity"
          selected={this.state.newEntity?.relatedEntity}
          messageHandler={this.messageHandler}
          breadcrumbsHandler={this.breadcrumbsHandler}
          required={validationRules.generalData?.relatedEntity?.required}
        />
      )
    },
    {
      label: labels.entityRelationshipType,
      controlId: "entityRelationshipType",
      placeholder: labels.entityRelationshipType,
      type: "dropdown",
      dropDownOptions: this.state.entityRelationshipTypes,
      isSearchable: true
    }
  ];

  onRowClick = (_, row) => {
    this.open(row);
  };

  onEditClick = row => {
    this.onSelectedEntityLoad(row);
  };

  render() {
    return (
      <EntityRelationships
        {...this.renderProps()}
        onRowClick={this.onRowClick}
        contextMenuItems={this.state.contextMenuItems}
        validationRules={validationRules.generalData}
        inputFields={this.inputFields()}
        disabled={this.state.disabled}
      />
    );
  }
}

export default withKeycloak(withRouter(EntityRelationshipsContainer));
